import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const addOnStockSlice = createApi({
    reducerPath: "addOnStockSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getAddOnStock: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/addOnStock?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addAddOnStock: builder.mutation({
            query: (body) => ({
                url: "/addOnStock",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateAddOnStock: builder.mutation({
            query: ({ id, body }) => ({
                url: `/addOnStock/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteAddOnStock: builder.mutation({
            query: (id) => ({
                url: `/addOnStock/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetAddOnStockQuery,
    useAddAddOnStockMutation,
    useUpdateAddOnStockMutation,
    useDeleteAddOnStockMutation,
} = addOnStockSlice;
